module.exports = __webpack_public_path__ + "static/media/albertJanVanDenBerg.8114f031.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/albertJanVanDenBerg.jpg
// module id = 1660
// module chunks = 1